var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrame1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 190,
    viewBox: "0 0 154 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    clipPath: "url(#clip0_3508_2804)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8257 136.214C50.3562 168.079 101.048 184.922 146.884 187.889C160.164 188.741 173.574 188.368 186.68 186.173L204.237 132.169C157.548 139.926 105.166 127.406 65.4857 104.309C54.7636 98.0688 44.7206 90.7911 36.1516 82.1562L18.8257 136.214V136.214Z",
    stroke: "url(#paint0_linear_3508_2804)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9567 55.8391C26.9898 59.8305 -9.33825 78.1645 2.56879 111.972C5.77675 121.046 11.9181 129.188 18.8254 136.213L36.1512 82.1559C13.2764 58.9524 9.73614 27.0076 43.0007 10.8024C52.9569 5.95941 64.1559 3.36502 75.2537 1.94141L57.9567 55.8391V55.8391Z",
    stroke: "url(#paint1_linear_3508_2804)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.023 109.658C193.299 76.9553 143.128 59.6324 98.1293 55.4414C84.7773 54.1908 71.2662 54.1509 57.9575 55.8406L75.2545 1.94296C122.001 -3.92444 173.762 9.06102 212.633 33.2092C222.936 39.6088 232.531 47.0329 240.537 55.814L223.009 109.658H223.023Z",
    stroke: "url(#paint2_linear_3508_2804)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.487 169.425C87.1618 163.252 38.2186 145.17 29.4184 111.682C26.3983 100.2 30.8056 89.1971 40.9786 82.0524L58.2756 28.1016C18.7107 55.8021 75.8038 94.346 101.583 104.923C112.912 109.567 124.805 113.066 136.943 115.381L119.473 169.412L119.487 169.425Z",
    stroke: "url(#paint3_linear_3508_2804)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.218 109.806L197.461 111.096L214.96 57.2253C185.553 26.4247 130.238 10.8582 86.8292 17.75C76.6995 19.3599 66.5843 22.3268 58.3043 28.1011L41.0073 82.052C75.2545 58.1699 133.128 71.9271 166.999 89.2366C177.75 94.7315 187.894 101.437 196.232 109.806H196.218Z",
    stroke: "url(#paint4_linear_3508_2804)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.461 111.092C229.41 144.727 193.414 170.844 155.482 172.347C143.431 172.826 131.293 171.669 119.487 169.434L136.957 115.403C164.601 120.658 237.372 121.576 227.402 78.0696C225.61 70.273 220.581 63.155 214.945 57.2344L197.446 111.105L197.461 111.092Z",
    stroke: "url(#paint5_linear_3508_2804)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.551 55.8169C211.044 23.4331 161.479 6.19011 116.915 1.71971C85.7743 -1.40692 31.2678 0.389214 19.2596 34.3829C7.19359 68.523 51.397 98.166 78.9393 111.418C119.024 130.696 171.797 141.965 216.188 129.552C255.926 118.442 267.458 85.4334 240.566 55.8169H240.551Z",
    stroke: "url(#paint6_linear_3508_2804)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.462 107.968C243.687 131.384 245.435 162.65 212.821 178.323C173.198 197.362 119.241 188.036 79.9217 173.307C48.2611 161.453 -0.508571 135.495 0.170592 98.5878C0.849755 61.6803 49.894 54.4691 79.7339 54.5356C129.833 54.6287 187.721 72.5769 221.462 107.981V107.968Z",
    stroke: "url(#paint7_linear_3508_2804)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.96 57.2248C236.534 79.8695 227.864 106.625 196.593 115.061C165.323 123.496 130.18 116.671 101.597 104.936C78.8525 95.5957 43.984 75.745 45.7036 48.7895C47.6399 18.6143 92.9705 14.9954 117.261 16.765C152.274 19.3195 191.29 32.4247 214.96 57.2248V57.2248Z",
    stroke: "url(#paint8_linear_3508_2804)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.659 112.387C178.183 89.8225 144.962 77.183 114.154 72.3134C89.4151 68.4018 49.9803 67.191 33.6081 89.0508C14.2881 114.849 49.8647 141.964 71.4389 153.113C99.5592 167.642 134.659 175.731 166.869 171.407C201.217 166.804 224.337 140.713 198.659 112.387Z",
    stroke: "url(#paint9_linear_3508_2804)",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3508_2804",
    x1: 18.0165,
    y1: 134.896,
    x2: 205.263,
    y2: 134.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3508_2804",
    x1: -0.465774,
    y1: 69.3434,
    x2: 76.2652,
    y2: 69.3434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3508_2804",
    x1: 56.9604,
    y1: 55.4548,
    x2: 241.361,
    y2: 55.4548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3508_2804",
    x1: 27.7711,
    y1: 98.271,
    x2: 137.882,
    y2: 98.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3508_2804",
    x1: 39.6779,
    y1: 63.9442,
    x2: 215.769,
    y2: 63.9442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3508_2804",
    x1: 118.576,
    y1: 114.498,
    x2: 229.063,
    y2: 114.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3508_2804",
    x1: 16.4851,
    y1: 67.6981,
    x2: 255.869,
    y2: 67.6981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3508_2804",
    x1: -0.551922,
    y1: 121.778,
    x2: 238.514,
    y2: 121.778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3508_2804",
    x1: 44.9233,
    y1: 67.5626,
    x2: 227.604,
    y2: 67.5626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3508_2804",
    x1: 27.3222,
    y1: 121.302,
    x2: 210.321,
    y2: 121.302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3508_2804"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 255,
    height: 188.481,
    fill: "white",
    transform: "translate(0.163574 0.542969)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame1);
export default __webpack_public_path__ + "static/media/frame1.891ecbb0b71451757edccef01935bc44.svg";
export { ForwardRef as ReactComponent };